import { render, staticRenderFns } from "./safetyGearStockAdjust.vue?vue&type=template&id=2218854b"
import script from "./safetyGearStockAdjust.vue?vue&type=script&lang=js"
export * from "./safetyGearStockAdjust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2218854b')) {
      api.createRecord('2218854b', component.options)
    } else {
      api.reload('2218854b', component.options)
    }
    module.hot.accept("./safetyGearStockAdjust.vue?vue&type=template&id=2218854b", function () {
      api.rerender('2218854b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/sas/safetyGearStockAdjust.vue"
export default component.exports